'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { styled } from 'styled-components';
const StyledImage = styled.img.withConfig({
  componentId: "aui__sc-1bz2eu8-0"
})(["width:100%;height:100%;object-fit:cover;"]);
export const Image = /*#__PURE__*/React.forwardRef(({
  src,
  alt,
  ...props
}, fRef) => {
  if (alt === '') {
    console.warn("AUI <Avatar.Image /> received alt=''. Use this only for decorative images.");
  }
  return /*#__PURE__*/React.createElement(StyledImage, _extends({
    src: src,
    alt: alt,
    ref: fRef
  }, props));
});